/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

// RESET

export const CHECK_RESET = 'CHECK_RESET';
export const CHECK_RESET_SUCCESS = 'CHECK_RESET_SUCCESS';

export const SET_REFRESH = 'SET_REFRESH';

// GET

export const GET_DAILY = 'GET_DAILY';
export const GET_DAILY_SUCCESS = 'GET_DAILY_SUCCESS';

export const GET_DAILY_REORDER = 'GET_DAILY_REORDER';
export const GET_DAILY_REORDER_SUCCESS = 'GET_DAILY_REORDER_SUCCESS';

export const GET_WEEKLY = 'GET_WEEKLY';
export const GET_WEEKLY_SUCCESS = 'GET_WEEKLY_SUCCESS';

export const GET_MONTHLY = 'GET_MONTHLY';
export const GET_MONTHLY_SUCCESS = 'GET_MONTHLY_SUCCESS';

export const GET_SINGLE_DAILY = 'GET_SINGLE_DAILY';
export const GET_SINGLE_DAILY_SUCCESS = 'GET_SINGLE_DAILY_SUCCESS';

export const SEARCH_DAILY = 'SEARCH_DAILY';
export const SEARCH_DAILY_SUCCESS = 'SEARCH_DAILY_SUCCESS';

// ADD

export const ADD_DAILY = 'ADD_DAILY';
export const ADD_DAILY_SUCCESS = 'ADD_DAILY_SUCCESS';

// HIDE

export const HIDE_DAILY = 'HIDE_DAILY';
export const HIDE_DAILY_SUCCESS = 'HIDE_DAILY_SUCCESS';

export const HIDE_WEEKLY = 'HIDE_WEEKLY';
export const HIDE_WEEKLY_SUCCESS = 'HIDE_WEEKLY_SUCCESS';

export const HIDE_MONTHLY = 'HIDE_MONTHLY';
export const HIDE_MONTHLY_SUCCESS = 'HIDE_MONTHLY_SUCCESS';

// CREATE

export const CREATE_DAILY = 'CREATE_DAILY';
export const CREATE_DAILY_SUCCESS = 'CREATE_DAILY_SUCCESS';

// EDIT 

export const EDIT_DAILY = 'EDIT_DAILY';
export const EDIT_DAILY_SUCCESS = 'EDIT_DAILY_SUCCESS';

// DELETE

export const DELETE_DAILY = 'DELETE_DAILY';
export const DELETE_DAILY_SUCCESS = 'DELETE_DAILY_SUCCESS';

export const DELETE_WEEKLY = 'DELETE_WEEKLY';
export const DELETE_WEEKLY_SUCCESS = 'DELETE_WEEKLY_SUCCESS';

export const DELETE_MONTHLY = 'DELETE_MONTHLY';
export const DELETE_MONTHLY_SUCCESS = 'DELETE_MONTHLY_SUCCESS';

// REORDER

export const REORDER_DAILY = 'REORDER_DAILY';
export const REORDER_DAILY_SUCCESS = 'REORDER_DAILY_SUCCESS';

// COMPLETE

export const COMPLETE_DAILY = 'COMPLETE_DAILY';
export const COMPLETE_DAILY_SUCCESS = 'COMPLETE_DAILY_SUCCESS';

export const COMPLETE_WEEKLY = 'COMPLETE_WEEKLY';
export const COMPLETE_WEEKLY_SUCCESS = 'COMPLETE_WEEKLY_SUCCESS';

export const COMPLETE_MONTHLY = 'COMPLETE_MONTHLY';
export const COMPLETE_MONTHLY_SUCCESS = 'COMPLETE_MONTHLY_SUCCESS';

export const SET_DAILY_TYPE = 'SET_DAILY_TYPE';

export const ERROR = 'DAILY_ERROR';